export enum AddressTypeEnum {
  USER_DEFINED = 'user_defined',
  SIMPLIFIED = 'simplified',
  DELIVERY = 'delivery',
  BILLING = 'billing',
  WAREHOUSE = 'warehouse',
  BRANCH_OFFICE = 'branch_office'
}
